module.exports = __webpack_public_path__ + "static/media/arrow-left.5d0a34bd.svg";